import React from "react";
import "./Theme.scss";

export const Theme: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return <React.Fragment>{children}</React.Fragment>;
};
